// extracted by mini-css-extract-plugin
export var labelWrapper = "_go-0";